/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_Key_CopiedInputs */

const en_settings_apikeys_key_copied = /** @type {(inputs: Settings_Apikeys_Key_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Key copied to clipboard`)
};

/**
* | output |
* | --- |
* | "Key copied to clipboard" |
*
* @param {Settings_Apikeys_Key_CopiedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_key_copied = /** @type {((inputs?: Settings_Apikeys_Key_CopiedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_Key_CopiedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_apikeys_key_copied(inputs)
});
export { settings_apikeys_key_copied as "settings.apikeys.key_copied" }